import React from "react";
import { ImgIcon, Spinner } from "../../assets";
import { user as userIcon } from "../../assets/icons";
import { useSelector } from "react-redux";
import { gravatar } from "../../helpers";
import { NavLink } from "react-router-dom";

export default function UnderPanelMini() {

	const user = useSelector(state => state.session.user);

	if (!user) return <Spinner />

	return <div className="lower-panel-mini" style={{ pointerEvents: "none" }}>
		<div className="maximum-width">
			<NavLink to="/me" className="flexy" style={{ pointerEvents: "initial" }}>
				<ImgIcon
					cover={true}
					src={user.picture || gravatar(user.email)}
					size={70}
				/>
				<div style={{ height: 70, width: 70 }}>
					<ImgIcon
						src={userIcon}
						size={30}
					/>
					<span
						className="featureFont"
						style={{ fontSize: "1rem", textTransform: "uppercase", marginTop: 2 }}
					>Account</span>
				</div>
			</NavLink >
		</div>
	</div>
}